/* global Swiper */
const thumbnailTeamSliderElements = document.querySelectorAll('[data-team-thumbnail-slider]');
const mainTeamSliderElements = document.querySelectorAll('[data-team-main-slider]');

// *******************************************************************************
// 1.0 - Top slider
// *******************************************************************************
const thumbnailTeamSliderOptions = {
  threshold: 10,
  touchRatio: 0.33,
  preloadImages: false,
  lazy: {
    loadPrevNext: false,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  loop: true,
  slidesPerView: 'auto',
  centeredSlides: true,
  spaceBetween: 0,
  watchSlidesProgress: true,
  slideToClickedSlide: true,
};

thumbnailTeamSliderElements.forEach((el, i) => {
  const mainSliderParent = el.closest('.mod-team');
  const arrowRight = mainSliderParent.querySelector('.swiper-button-next');
  const arrowLeft = mainSliderParent.querySelector('.swiper-button-prev');

  thumbnailTeamSliderOptions.navigation.nextEl = arrowRight;
  thumbnailTeamSliderOptions.navigation.prevEl = arrowLeft;

  const thumbnailTeamSlider = new Swiper(el, thumbnailTeamSliderOptions);

  thumbnailTeamSlider.on('slideChange', () => {
    mainTeamSliderElements[i].swiper.slideTo(thumbnailTeamSlider.realIndex);
  });
});

// *******************************************************************************
// 2.0 - Bottom slider
// *******************************************************************************

const mainTeamSliderOptions = {
  threshold: 10,
  touchRatio: 0.33,
  preloadImages: false,
  lazy: {
    loadPrevNext: false,
  },
  allowTouchMove: false,
  noSwiping: false,
  slidesPerView: 1,
  spaceBetween: 0,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false,
  },
  breakpoints: {
    1023: {
      spaceBetween: 30,
    },
  },
};

mainTeamSliderElements.forEach((el) => new Swiper(el, mainTeamSliderOptions));
